
(() => {
  function init() {
    document.querySelectorAll('.slideshow[data-enable-autoplay="true"]').forEach(section => {
      const button = section.querySelector('.slideshow-pause-toggle');
      const swiperElement = section.querySelector('.swiper');

      if (!button || !swiperElement || button.dataset.initialized) return;

      function connect() {
        const swiper = swiperElement.swiper;
        if (!swiper || !swiper.autoplay) return false;

        button.hidden = false;
        button.dataset.initialized = 'true';

        let paused = false;

        function sync() {
          if (paused && swiper.autoplay.running) {
            swiper.autoplay.stop();
          }
        }

        swiper.on('autoplayStart', sync);

        button.addEventListener('click', () => {
          paused = !paused;

          if (paused) {
            swiper.autoplay.stop();
          } else {
            swiper.autoplay.start();
          }

          button.setAttribute('aria-pressed', String(paused));
          button.setAttribute(
            'aria-label',
            paused ? 'Resume slideshow' : 'Pause slideshow'
          );
          button.querySelector('.slideshow-pause-icon').innerHTML = paused
  ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M8 5L19 12L8 19V5Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>'
  : '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M8 5V19M16 5V19" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
        });

        return true;
      }

      if (connect()) return;

      const observer = new MutationObserver(() => {
        if (connect()) observer.disconnect();
      });

      observer.observe(swiperElement, {
        attributes: true,
        childList: true,
        subtree: true
      });

      setTimeout(() => observer.disconnect(), 10000);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
